import React from "react";
import { Sparkles } from "lucide-react";

interface AppLogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const AppLogo: React.FC<AppLogoProps> = ({ size = "md", className = "" }) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
  };

  const iconSizes = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  };

  return (
    <div
      className={`${sizeClasses[size]} bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center shadow-lg ${className}`}
    >
      <Sparkles className={`${iconSizes[size]} text-white`} />
    </div>
  );
};

export default AppLogo;
